import PaginationAnchor from './PaginationAnchor'

export default PaginationAnchor
